import React, { useEffect, useState } from 'react'
import Resizer from "react-image-file-resizer";
// import Select from 'react-select/base';
import Select from 'react-select';
import { getLoginUserData } from '../../Helper/GlobalHelperFunction';
import { showCreateOrUpdate } from '../../Helper/ShowHelper/ShowHelper';
import { toast } from 'react-toastify';
import { GetAllClient } from '../../Helper/ClientHelper/ClientHelper';
import { GetAllAssets } from '../../Helper/AssetHelper/AssetHelper';


const CreateShowComponent = () => {

    const [clients, setClients] = useState([]);
    const [assets, setAssets] = useState([]);
    const [loading, setLoading] = useState(false);
    const [inputField, setInputField] = useState(
        {
            showId: 0,
            showName: "",
            startDate: "",
            endDate: "",
            location: "",
            area: "",
            showImage: "",
            showType: "",
            isActive: true,
            clientId: 0,
            description: "",
            createdBy: getLoginUserData().id,
            updatedBy: 0,
        }
    )
    const [base64, setBase64] = useState("");
    useEffect(() => {
        getAllClients();
        getAssets();
    }, [])

    const handleImage = (evt) => {
        const file = evt.target.files[0];
        if (file) {
            Resizer.imageFileResizer(
                file,
                800, // Max width
                800, // Max height
                "webp", // Output format
                90, // Quality (0 to 100)
                0, // Rotation (in degrees)
                (uri) => {
                    setBase64(uri); // Compressed Base64 string
                },
                "base64" // Output type
            );
        }
    }

    const handleInputChange = (evt) => {
        const { name, value } = evt.target;
        setInputField((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const [inputmultiFields, setinputmultiFields] = useState([{
        showAssetId: 0,
        assetId: 0,
        quantity: 0,
        isAdditional: null,
        createdBy: getLoginUserData().id,
        updatedBy: getLoginUserData().id,

    }]);

    const addInputField = () => {
        setinputmultiFields([...inputmultiFields, {
            showAssetId: 0,
            assetId: 0,
            quantity: 0,
            isAdditional: null,
            createdBy: getLoginUserData().id,
            updatedBy: getLoginUserData().id,
        }])

    }

    const removeInputFields = (index) => {
        const rows = [...inputmultiFields];
        rows.splice(index, 1);
        setinputmultiFields(rows);
    }

    const handleChange = (index, evnt) => {
        const { name, value } = evnt.target;

        const parsedValue = value === "true" ? true : value === "false" ? false : value;

        setinputmultiFields((prevData) => {
            const updatedData = [...prevData];
            updatedData[index] = {
                ...updatedData[index],
                [name]: parsedValue,
            };
            return updatedData;
        });
    };


    const getAllClients = async () => {
        const res = await GetAllClient();
        var clients = res.filter((x) => x.clientId !== 1);
        setClients(clients);
    }

    const getAssets = async () => {
        const res = await GetAllAssets();
        setAssets(res);
    }

    const save = async (evt) => {
        setLoading(true);
        evt.preventDefault();

        var data = {
            ...inputField,
            showImage: base64,
            showAssets: inputmultiFields,
        }
        console.log(data);
        debugger
        const res = showCreateOrUpdate(data);
        if (res) {
            toast.success("show created successfully");
            setLoading(false);
        }
        else {
            toast.error("Error creating show");
            setLoading(false);
        }
    }


    return (
        <div>
            <div className="container-fluid mt-2">
                <div className="card mb-3">
                    <div className="card-body">
                        <h2>Add Show</h2>
                    </div>
                </div>

                <form onSubmit={save} className='form-control' action="">
                    <div className="row p-3">
                        <div className="col-sm-12 d-flex flex-wrap">
                            <div className="col-sm-5 col-12">
                                <div className="form-group">
                                    <label ><b>Show Name</b></label>
                                    <input type="text" className="form-control" name='showName' onChange={handleInputChange} placeholder="Enter Show Name" />
                                </div>
                                <div className="form-group">
                                    <label ><b>Start Date</b></label>
                                    <input type="date" className="form-control" name='startDate' onChange={handleInputChange} />
                                </div>
                                <div className="form-group d-flex flex-wrap">
                                    <div className="col-sm-12">
                                        <label ><b>Show Image</b></label>
                                    </div>
                                    <div className="col-sm-12 d-flex align-items-center justify-content-around">

                                        <div className="col-sm-9">
                                            <input
                                                type="file"
                                                accept="image/*"
                                                name="imageSrc"
                                                className="form-control" onChange={handleImage}
                                            />
                                        </div>
                                        <div className="col-sm-3 border p-2 rounded text-center">
                                            {base64 ? <img className='img-fluid' src={base64} alt="" /> : "No Image is selected"}
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="col-sm-2">

                            </div>
                            <div className="col-sm-5 col-12">
                                <div className="col-12 d-flex">
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label ><b>Location</b></label>
                                            <input type="text" className="form-control" name='location' onChange={handleInputChange} placeholder="Enter Location" />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label ><b>Area</b></label>
                                            <input type="text" className="form-control" name='area' onChange={handleInputChange} placeholder="Enter Area" />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label ><b>End Date</b></label>
                                    <input type="date" className="form-control" name='endDate' onChange={handleInputChange} />
                                </div>
                                <div className="form-group">
                                    <label ><b>Client</b></label>
                                    <select className="form-select" name='clientId' onChange={handleInputChange} >
                                        <option value="NONE">NONE</option>
                                        {clients.map((item) => {
                                            return <option key={item.clientId} value={item.clientId}>{item.clientName}</option>
                                        })}
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label ><b>Show Type</b></label>
                                    <select className="form-select" name='showType' onChange={handleInputChange} >
                                        <option value="NONE">NONE</option>
                                        <option value="A1">A1 (09sqm-20sqm)</option>
                                        <option value="A2">A2 (21sqm-55sqm)</option>
                                        <option value="A3">A3 (56sqm-100sqm)</option>

                                    </select>
                                </div>
                                <div className="mb-3 mt-4 px-3 d-grid ">
                                    {loading && <img src="/Assets/loader.gif" alt="loading..." />}
                                    <button type="submit" className="btn btn-lg btn-block text-light loginBtn" style={{ backgroundColor: "#09183b" }}>Save</button>
                                </div>

                            </div>

                            <div className="col-sm-12 col-12 mt-3">
                                <h3>Assign Assets</h3>
                            </div>

                            <div className="col-sm-12">
                                {
                                    inputmultiFields.map((data, index) => {
                                        const { assetId, quantity, isAdditional } = data;


                                        return (
                                            // <div>

                                            <div className="form-group row" key={index}>

                                                <div className='col-sm-4 m-1'>
                                                    {/* <Select
                                                            onChange={(evnt) => handleChange(index, evnt)} value={assetId} name="assetId" options={assets.map((item) => ({
                                                                value: item.assetId,
                                                                label: item.assetName
                                                            }))} placeholder="Enter asset name"
                                                        /> */}
                                                    <select onChange={(evnt) => handleChange(index, evnt)} value={assetId} name="assetId" className="form-select" placeholder="Enter Asset name" >
                                                        <option value="NONE">NONE</option>
                                                        {assets.map((item) => {
                                                            return <option key={item.assetId} value={item.assetId}>{item.assetName}</option>

                                                        })}
                                                    </select>
                                                </div>
                                                <div className='col-sm-2'>
                                                    <input type="number" onChange={(evnt) => handleChange(index, evnt)} value={quantity} name="quantity" className="form-control" placeholder="Enter Quantity" />
                                                </div>

                                                <div className='col-sm-2'>
                                                    <select onChange={(evnt) => handleChange(index, evnt)} name="isAdditional" className="form-select" placeholder="Enter Asset Type" >
                                                        <option value="NONE">NONE</option>
                                                        <option value={true}>Yes</option>
                                                        <option value={false}>No</option>
                                                    </select>
                                                </div>

                                                <div className='col-sm-1'>
                                                    <span className="btn btn-outline-success " onClick={addInputField}>Add</span>
                                                </div>
                                                <div className="col-sm-1">
                                                    {(inputmultiFields.length !== 1) ? <span className="btn btn-outline-danger" onClick={removeInputFields}>x</span> : ''}
                                                </div>

                                            </div>

                                            // </div>
                                        )
                                    })
                                }
                            </div>
                        </div>

                    </div>
                </form>
            </div>
        </div>
    )
}

export default CreateShowComponent